import { ReactNode } from "react";
import { SearchForm, Bubbles } from "components/molecules";
import { useCountryForm } from "hooks";
import styled from "styled-components";
import { AvailableLanguages } from "utils/types";

interface OceanProps {
  children: ReactNode;
  showFinder?: boolean;
  language?: AvailableLanguages;
  setMatchingPath: (path: string) => void;
}

const Ocean = styled.div`
  /* 100% rather than 100vw: with a vertical scrollbar present, 100vw is wider
     than the content box and forces a horizontal scrollbar. */
  width: 100%;
  /* min-height, not height: the mobile explorer scrolls the document (its
     country list runs several screens long), and a fixed 100vh left the
     gradient behind after the first screenful — everything below it scrolled
     over the blank body. */
  min-height: 100vh;
  background: linear-gradient(0deg, #182848, #2980b9);
`;

// TODO: replace prop drilling with global state

export const OceanScene = ({
  children,
  showFinder,
  language,
  setMatchingPath,
}: OceanProps) => {
  const {
    onChange,
    onSubmit,
    inputValue,
    typedValue,
    suggestions,
    isOpen,
    activeIndex,
    previewSuggestion,
    commitSuggestion,
    resetPreview,
    onKeyDown,
    onFocus,
    onBlur,
  } = useCountryForm(language, setMatchingPath);

  return (
    <Ocean>
      {showFinder && (
        <SearchForm
          inputValue={inputValue}
          typedValue={typedValue}
          onChange={onChange}
          onSubmit={onSubmit}
          suggestions={suggestions.map((s) => ({
            primaryLabel: s.primaryLabel,
            secondaryLabel: s.secondaryLabel,
          }))}
          isOpen={isOpen}
          activeIndex={activeIndex}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          onSuggestionHover={previewSuggestion}
          onSuggestionSelect={commitSuggestion}
          onSuggestionsMouseLeave={resetPreview}
        />
      )}
      <Bubbles />
      {children}
    </Ocean>
  );
};
